import { Link } from '@inertiajs/react'
import { ChevronRight } from 'lucide-react'
import { reportsMonthlyPeriodPath } from '@/shared/lib/routes'
import { t } from '@/shared/lib/i18n'

export interface MonthlyPeriodSlot {
  departmentId: number
  departmentName: string
  siteName: string | null
  reportStartDate: string
  reportEndDate: string
  unreviewedNonCompliantCount: number
  monthInProgress: boolean
}

interface Props {
  slot: MonthlyPeriodSlot
}

// A period with completed tasks but no persisted report row. Opening it navigates
// to the period route, which lazily find-or-creates the anchor and renders the
// live report (REBUILD-141 / REBUILD-502 — no Open period label, no manual generation).
const ReportMonthPeriodSlotRow = ({ slot }: Props) => (
  <Link
    href={reportsMonthlyPeriodPath({
      department_id: slot.departmentId,
      period_start: slot.reportStartDate,
    })}
    className="flex items-center justify-between gap-3 rounded border border-dashed border-muted-foreground/30 px-3 py-3 transition-colors hover:bg-muted/50"
    aria-label={`${t('approvals.viewNow')}: ${slot.departmentName}`}
  >
    <div className="min-w-0 flex-1">
      <div className="flex flex-col gap-0.5">
        <span className="text-base font-semibold text-foreground">{slot.departmentName}</span>
        <span className="text-sm text-muted-foreground">{slot.siteName ?? '—'}</span>
      </div>
    </div>
    <div className="flex shrink-0 items-center gap-2 self-center">
      {slot.monthInProgress && (
        <span className="text-sm font-medium text-muted-foreground">
          {t('reports.monthly.derivedStatusInProgress')}
        </span>
      )}
      <span className="inline-flex h-8 items-center justify-center rounded-md border border-input bg-background px-3 text-sm font-medium">
        {t('approvals.viewNow')}
      </span>
      <ChevronRight className="size-4 text-muted-foreground" aria-hidden />
    </div>
  </Link>
)

export default ReportMonthPeriodSlotRow
